
import '../VacanciesPage/VacanciesPage.scss'


const VacanciesPage = ()=>{
return (
   <div className='vacancies-page'>
    <div className='vacancies-page__container'>
        <h2 className='vacancies-page__title'>Sorry, there are  no open positions...</h2>
        
    </div>
    
   </div>
    
    
    
)
}

export default VacanciesPage;